import PropTypes from 'prop-types'
import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import withAuth from 'components/withAuth'
import paths from 'constants/paths'

export function RoutePrivate({
  component: Component, loading, user, ...others
}) {
  if (loading) return null

  return (
    <Route
      {...others}
      render={
        (props) => {
          if (loading) return null

          if (user) {
            return (
              <Component {...props} userEmail={user.email} />
            )
          }
            return (
              <Redirect
                to={{
                  pathname: paths.SIGN_IN,
                  state: { redirectedFrom: props.location.pathname },
                }}
              />
            )
        }
      }
    />
  )
}

RoutePrivate.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  loading: PropTypes.bool,
  user: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
}

export default withAuth(RoutePrivate)


// WEBPACK FOOTER //
// ./src/components/RoutePrivate/RoutePrivate.js